var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiImagesWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.207,
    height: 21.5,
    viewBox: "0 0 23.207 21.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2228",
    "data-name": "Raggruppa 2228",
    transform: "translate(-16541.566 21236.055)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2227",
    "data-name": "Raggruppa 2227"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2225",
    "data-name": "Raggruppa 2225",
    transform: "translate(16539.566 -21238.055)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3538",
    "data-name": "Tracciato 3538",
    d: "M3,7.333A4.535,4.535,0,0,1,7.713,3H19.495a4.535,4.535,0,0,1,4.713,4.333V18.166A4.535,4.535,0,0,1,19.495,22.5H7.713A4.535,4.535,0,0,1,3,18.166Z",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3539",
    "data-name": "Tracciato 3539",
    d: "M3,15.278l3.305-3.035a2.49,2.49,0,0,1,3.6.3l2.241,2.973a2.492,2.492,0,0,0,3.43.443l2.853-2.144a2.513,2.513,0,0,1,3.158.145l2.616,2.4",
    transform: "translate(0 0.721)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_80",
    "data-name": "Ellisse 80",
    cx: 2.164,
    cy: 2.164,
    r: 2.164,
    transform: "translate(15.983 6.246)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiImagesWhite);
export default __webpack_public_path__ + "static/media/ai-images-white.6d871968d96d6a1e788f2c4826d5ddba.svg";
export { ForwardRef as ReactComponent };